import React, { useEffect, useState } from 'react';
import { Button, Input, Upload } from 'antd';

import UserStore from 'stores/UserStore';

import { API_ROOT as BASE_URL } from '@partsbadger/utils';

const FILE_URL = `${BASE_URL}/customer/files/`;

// import { Container } from './styles';

interface IProps {
    value: any;
    handleChange: (value: any) => void;
}

const ExtraInput: React.FC<IProps> = ({ value, handleChange }) => {
    return (
        <Input.TextArea
            // size="small"
            style={{ marginLeft: '5px' }}
            value={value}
            required
            onChange={event => {
                handleChange(event.target.value);
            }}
        />
    );
};

export default ExtraInput;
